<template>
    <div class=" flex align-cen"
    id="couvid"
     v-loading="loading"
    element-loading-text="课程加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    >
            <div class="left">
         <div class="helpDetail-navbar">
            <div class="chapter-list">
                    <el-collapse v-model="activeNames">
                        <el-collapse-item v-for="(item,index) in list" :key="item.id"  :name="item.id">
                            <template slot="title">
                                <div class="numlist-tit flex align-cen">
                                    <div class="tit-name">
                                      {{item.name}}
                                    </div>
                                </div>
                            </template>
                            <div v-for="(childItem,childIndex) in item.children" :key="childItem.id" class="childrenlist flex align-cen">
                               <div class="childrenlist-tit"
                               :class="{current: detailid === childItem.id}"
                                @click="openDetail(childItem.id,index,childIndex)"
                               >
                                 {{childItem.name}}
                               </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
         </div>
        </div>
        </div>
        <div class="right">
            <div class="right-tit flex align-cen">
                {{$route.query.title}}
                 <i class="icon-al-menu" @click="toggleMenu"></i>
            </div>
            <div class="itembox" v-if="info.document" id="nr">
             <FilePreview :item="info" />
              <!-- 附加材料 - 最简版 -->
                <!-- 附加材料下载 -->
                 <MaterialsDownload :materials="info.materials" />
            <!-- <div v-html="content" v-if="content" class="nr" id="nr"></div> -->
            </div>
                    <div v-else class="flex align-cen emtey">
                <div>
                    <i class="icon-al-cry-fill"></i>
                    <p>{{emteyText}}</p>
                </div>
            </div>
         <div class="right-bot flex align-cen">
            
                <div @click="openDetail(prevId,publicIndex,prevIndex)">
                    <i class="icon-al-angle-left" ></i>
                    {{prev}}
                    </div>
                <div class="mft" @click="openDetail(nextId,publicIndex,nextIndex)">
                    {{next}}
                 <i class="icon-al-angle-right"></i>
                    </div>
            </div>
        </div>
          <div class="rMenu" :class="{active:isShow}">
				   <div class="rMenu-left">
         <div class="helpDetail-navbar">
            <div class="chapter-list">
                    <el-collapse v-model="activeNames">
                        <el-collapse-item v-for="(item,index) in list" :key="item.id"  :name="item.id">
                            <template slot="title">
                                <div class="numlist-tit flex align-cen">
                                    <div class="tit-name">
                                      {{item.name}}
                                    </div>
                                </div>
                            </template>
                            <div v-for="(childItem,childIndex) in item.children" :key="childItem.id" class="childrenlist flex align-cen">
                               <div class="childrenlist-tit"
                               :class="{current: detailid === childItem.id}"
                               @click="openDetail(childItem.id,index,childIndex)"
                               >
                                 {{childItem.name}}
                               </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
         </div>
        </div>
        </div>
			</div>
    </div>
</template>
<script>
import {courseChapterTree,courseChapterDetail} from "@/api/enterprise/index"  //获取课程章节详情
import FilePreview from '../../components/FilePreview.vue'
import MaterialsDownload from '../../components/MaterialsDownload.vue'
export default {
    name:'enCourseVideo',
    components: {
    FilePreview,
    MaterialsDownload
  },
    data () {
        return {
            info:{},
            businessInfo:{},
            loading:false,
            centerDialogVisible:false,
            list:[],
            serch:'',
            activeNames:[],
            detailid:'',
            content:'',
            next:'',
            prev:'',
            publicIndex:'',
            nextIndex:'',
            nextId:'',
            prevId:'',
            prevIndex:'',
            publicLebfth:'',
            user_info:'',
            autodetai:true,
            isShow:false,
            activeName:'',
            isweixin:false,
            emteyText:'加载中'
        }
    },
    created () {
        this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
        if(this.businessInfo){
         let that = this
              //    异步同步执行
            this.getInfo().then(function(){
            if(that.autodetai) that.openDetail(that.detailid,that.$route.query.index,that.$route.query.childIndex)
            })
        }else{
         this.$util.Notifi('请先登录','error','fa-exclamation-circle');
         this.$router.push({
            name:'enHlyhLogin',
            query: {
               redirectUrl:'HlrjenCourseDetail',
               id:this.$route.query.id,
               currentNav1:1
            }
         })
        }
    },
    methods: {
           // 侧边栏
            toggleMenu: function() {
				this.isShow = !this.isShow
			},
        async getInfo(){
            this.loading = true
           await courseChapterTree({id:this.$route.query.id,businessId:this.businessInfo.id},'get')
            .then(res =>{
                 this.loading = false
                 if(res.code == 0){
                    this.list = res.data
                       this.detailid = this.$route.query.chapterId
                     this.activeName = res.data[0].name + '-' +res.data[0].children[0].name
                     this.autodetai = true
                      for (const key in res.data) {
                        this.activeNames.push(res.data[key].id)
                        }
                 }else{
                    this.autodetai = false
                    this.$message.error(res.msg) 
                 }
            })
            .catch(err =>{this.loading = false})
        },
                        detail(){
               courseChapterDetail({
                id:this.detailid,
                businessId:this.businessInfo.id
              },'get')
            .then(res => {
              if(res.code == 0){
                this.info = res.data 
               if(res.data.document){
                 this.content = res.data.document
                  this.$nextTick(function(){
                 const imgDomArray = document.getElementById('nr')
             imgDomArray.setAttribute('ondragstart','return false')
             imgDomArray.setAttribute('oncontextmenu','return false')
              })
               }else{
                this.document = ''
                this.emteyText = '暂无内容，请先去上传课件'
               }
              }else{
                this.emteyText = res.msg
                this.document = ''
                this.info = {}
              }
            })
            .catch(err => {
            })
        },
        // 切换详情
        openDetail(id,strindex,strchildIndex){
        this.isShow = false
        this.detailid  = id
        let index,
            childIndex
        if(strindex || strchildIndex){
          index = Number(strindex)
          childIndex = Number(strchildIndex)
        }else{
            this.list.forEach((outerItem, outerIndex) => {
                    if(outerItem.children){
                           outerItem.children.forEach((childItem, childIn) => {
                    if (childItem.id == id) {
                        index = Number(outerIndex)
                        childIndex = Number(childIn)
                    }
                });
                    }
                });
        }
     this.publicIndex = index
        this.publicLebfth = this.list[index].children.length-1
         this.activeName = this.list[index].name + '-' +this.list[index].children[childIndex].name
     if(childIndex >= this.list[index].children.length-1){
             this.next = "暂无小节"
        }else{
             this.next = this.list[index].children[childIndex+1].name
             this.nextId = this.list[index].children[childIndex+1].id
             this.nextIndex = childIndex+1
        }
        if(childIndex == 0){
        this.prev = "暂无小节"
        }else{
           this.prev = this.list[index].children[childIndex-1].name 
           this.prevId = this.list[index].children[childIndex-1].id
           this.prevIndex = childIndex-1
        }

        this.detail()
        },
        // 返回
        reback(){
            this.$router.push(
                {
                    name:'enCourseDetail',
                    query:{
                        id:this.$route.query.id,
                        currentNav1:this.$route.query.currentNav1
                    }
                }
            )
        },
    },
}
</script>
<style lang="scss" scoped>
.ql-align-center{
    text-align: center;
}
#couvid{
    width: 100%;
    margin: 0 auto;
    height: 100vh;
     .mobil-share-btn{
        display: none;
    }
    .left{
        width: 316px;
        height: inherit;
        background: #F7F7F7;
         position: fixed;
        left: 0;
        top: 0;
        .el-input{
            width: 90%;
            margin: 0 auto;
            display: block;
            margin-top: 20px;
        }
        .helpDetail-navbar{
           margin: 0 auto;
           padding: 0 30px;
           margin-top: 40px;
            overflow: auto;
           height: calc(100% - 100px);
           .numlist-tit{
            .tit-name{
                font-size: 15px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #555555;
                line-height: 20px;
            }
           }
           .childrenlist-tit{
            cursor: pointer;
            padding-left: 20px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #989898;
            line-height: 50px;
           }
           .current{
            background: #D3ECFF;
            color: #1684FC;
            width: 100%;
           }
           .el-collapse{
            border: none;
            
           }
        }
    }
    .right{
        width: calc(100% - 316px);
        height: inherit;
        position: relative;
         position: fixed;
        left: 316px;
        .right-tit{
            font-size: 32px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #555555;
            line-height: 48px;
            padding: 20px 40px;
            i{
                display: none;
            }
        }
        .itembox{
            height: calc(100% - 180px);
            overflow-y: auto;
        }
        .nr{
            width: 90%;
            margin: 0 auto;
            margin-bottom: 50px;
            border-bottom: 1px solid #ccc;
            height: calc(100% - 180px);
            overflow: auto;
        }
        .right-bot{
            position: absolute;
            width: 90%;
            left: 5%;
            bottom: 30px;
            cursor: pointer;
            color: #BDBDBD;
            line-height: 36px;
            font-size: 14px;
            i{
                font-size: 12px;
            }
        }
        .emtey{
            justify-content: center;
            text-align: center;
            padding-top: 20vh;
             color: #ccc;
            i{
                font-size: 50px;
                color: #ccc;
                
            }
            .btn{
               padding: 10px 20px;
               background: #155bd4;
               color: #fff;
               border-radius: 5px;
               margin-top: 20px;
               cursor: pointer;
            }
        }
    }
    .rMenu{
        display: none;
    }
}
@media (max-width: 640px){
    #couvid{margin-top: -56px;}
    .dia-btn{
        display: none;
    }
    .itembox{
        margin-top: 20px;
    }
      .mobil-dia-btn{
        display: block;
        .mobil-share-btn{
            div{
                height: 32px;
				line-height: 30px;
				font-size: 14px;
				padding: 0 16px;
				border-radius: 2px;
				font-family: inherit;
				border-width: 1px;
				border-style: solid;
				text-align: center;
				vertical-align: middle;
				box-sizing: border-box;
				cursor: pointer;
				transition: all .3s;
				background: $base-color-btn;
				color: #fff;
                margin: 20px auto;
                margin-bottom: 0;
            }
        }
    }
    .el-dialog{
        margin-top: 10vh !important;
    }
  #couvid{
    width: 100%;
    .left{
        display: none;
    }
    .right{
        left: 0;
          .right-tit{
            padding: 0;
            font-size: 16px;
            text-align: center;
            height: 50px;
            line-height: 50px;
           box-shadow: 0px 0px 10px rgba(0,0,0,.4);
           position: relative;
           display: block;
           i{
            position: absolute;
            display: block;
            right: 20px;
            top: 0px;
            display: block;
           }
            .share{
            position: absolute;
            left: 20px;
            top: 0;
        }
        }
        
        .nr{
            margin-top: 10px;
        }
        width: 100%;
    }
  }
  	.rMenu{
        display: block !important;
		width: 70vw;
		height: 100%;
		position: fixed;
		left: 0;
		top: 0;
		transform: translateX(-71vw);
		background: #fff;
		transition: transform 0.5s;
         box-shadow:3px 0px 5px rgba(0,0,0,.4);
      .rMenu-left{
        width: 100%;
        height: 100%;
        overflow: hidden;
                overflow: auto;
        background: #F7F7F7;
        .el-input{
            width: 90%;
            margin: 0 auto;
            display: block;
            margin-top: 20px;
        }
        .helpDetail-navbar{
           margin: 0 auto;
           padding: 0 30px;
           margin-top: 40px;
           .numlist-tit{
            .tit-name{
                font-size: 15px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #555555;
                line-height: 20px;
            }
           }
           .childrenlist-tit{
            cursor: pointer;
            padding-left: 20px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #989898;
            line-height: 50px;
           }
           .current{
            background: #D3ECFF;
            color: #1684FC;
            width: 100%;
           }
           .el-collapse{
            border: none;
            
           }
        }
    }
	}
	.active{
		transform: translateX(0vw);
	}
}
@media (max-width: 640px){
    #helpDetail{margin-top: -56px;}
    .dia-btn{
        display: none;
    }
      .mobil-dia-btn{
        display: block;
        .mobil-share-btn{
            div{
                height: 32px;
				line-height: 30px;
				font-size: 14px;
				padding: 0 16px;
				border-radius: 2px;
				font-family: inherit;
				border-width: 1px;
				border-style: solid;
				text-align: center;
				vertical-align: middle;
				box-sizing: border-box;
				cursor: pointer;
				transition: all .3s;
				background: $base-color-btn;
				color: #fff;
                margin: 20px auto;
                margin-bottom: 0;
            }
        }
    }
    .el-dialog{
        margin-top: 10vh !important;
    }
  .helpDetail{
    width: 100%;
    .left{
        display: none;
    }
    .right{
        left: 0;
          .right-tit{
            padding: 0;
            font-size: 16px;
            text-align: center;
            height: 50px;
            line-height: 50px;
           box-shadow: 0px 0px 10px rgba(0,0,0,.4);
           position: relative;
           display: block;
           i{
            position: absolute;
            display: block;
            right: 20px;
            top: 0px;
            display: block;
           }
            .share{
            position: absolute;
            left: 20px;
            top: 0;
        }
        }
        
        .nr{
            margin-top: 10px;
        }
        width: 100%;
    }
  }
  	.rMenu{
        display: block !important;
		width: 70vw;
		height: 100%;
		position: fixed;
		left: 0;
		top: 0;
		transform: translateX(-71vw);
		background: #fff;
		transition: transform 0.5s;
         box-shadow:3px 0px 5px rgba(0,0,0,.4);
      .rMenu-left{
        width: 100%;
        height: 100%;
        overflow: hidden;
                overflow: auto;
        background: #F7F7F7;
        .el-input{
            width: 90%;
            margin: 0 auto;
            display: block;
            margin-top: 20px;
        }
        .helpDetail-navbar{
           margin: 0 auto;
           padding: 0 30px;
           margin-top: 40px;
           .numlist-tit{
            .tit-name{
                font-size: 15px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #555555;
                line-height: 20px;
            }
           }
           .childrenlist-tit{
            cursor: pointer;
            padding-left: 20px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #989898;
            line-height: 50px;
           }
           .current{
            background: #D3ECFF;
            color: #1684FC;
            width: 100%;
           }
           .el-collapse{
            border: none;
            
           }
        }
    }
	}
	.active{
		transform: translateX(0vw);
	}
}
::v-deep {
.ql-video{
    max-width: 100%;
}
     .mobil-dia-btn{
        display: none;
    }
    .el-collapse-item__wrap,.el-collapse-item__header{
                background: transparent;
                border: none;
            }
    .el-collapse-item__content{
        padding-bottom: 0;
    }
    @media (max-width: 640px){
    .el-dialog{
        margin-top: 10vh !important;
    }
       .mobil-dia-btn{
        display: block;
    }
}
    .dia-can{
        .canvas{
            position:relative !important;
            top: 0 !important;
            display: block;
            margin: 0 auto;
        }
    }
        .dia-btn{
            width: 100px;
        	height: 32px;
				line-height: 30px;
				font-size: 14px;
				padding: 0 16px;
				border-radius: 2px;
				font-family: inherit;
				border-width: 1px;
				border-style: solid;
				text-align: center;
				vertical-align: middle;
				box-sizing: border-box;
				cursor: pointer;
				transition: all .3s;
				background: $base-color-btn;
				color: #fff;
                margin: 20px auto;
                margin-bottom: 0;
    }
    .el-dialog__body{
        padding: 20px 10px;
    }
}
</style>
